/** Copyright (c) 2022 T. Rowe Price. All rights reserved. */

import './FluctuationRenderer.scss';

import React from 'react';

import ValueIndicator from 'components/shared/ValueIndicator/ValueIndicator';

const FluctuationRenderer = ({ valueFormatted, value }) => {
  return (
    <div className="fluctuation-renderer">
      {valueFormatted}
      <ValueIndicator value={value} />
    </div>
  );
};

export default FluctuationRenderer;
